module.exports = __webpack_public_path__ + "static/media/Obelis.b12b6484.md";